var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFableButterflyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    color: "#626672",
    stroke: "currentColor",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fable butterfly outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C36 9 62 35 63 70C58 52 39 61 25 49C15 40 17 26 7 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18C77 30 68 54 67 70C74 53 86 57 90 37C92 29 94 22 96 18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 62C43 59 56 65 59 72C64 82 41 91 35 93C46 78 32 68 38 62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72C83 58 77 79 86 93C78 89 63 80 71 72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFableButterflyOutline);
export default __webpack_public_path__ + "static/media/fable-butterfly-outline.ee6aa6d656bbca514afb89ea074fdd0c.svg";
export { ForwardRef as ReactComponent };